export const UI_CONFIG = {
    LAST_REGISTERED_USERS_PER_PAGE: 10,
    USERS_PER_PAGE: 20,
    PROVISIONED_MACHINES_PER_PAGE: 100,
    MACHINES_WITH_ERROR_PER_PAGE: 20
}